import React, { useState, useEffect } from "react";
import "./menu.css";
import { getFilteredMenu } from "./menuPermissions";

export const gestionDeAlmacenMenu = [
  // Nivel principal: Mostrador
  {
    title: "Mostrador",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "exportación/mostrador",
    permiso: [3000, 3001, 3002, 3003, 3004], // Rango original: 3000 a 3005 (último permiso es 3004)
    hijos: [
      {
        title: "Captura",
        icono: "Dashboard.svg",
        enlace: "Capture", // Modificado de URL::route('export.capture')
        activo: "exportación/mostrador/captura",
        permiso: [3000],
      },
      {
        title: "Asignación",
        icono: "Dashboard.svg",
        enlace: "Assignment", // Modificado de URL::route('export.assignment')
        activo: "exportación/mostrador/asignación",
        permiso: [3001],
      },
      {
        title: "Entradas",
        icono: "Dashboard.svg",
        enlace: "Entries", // Modificado de URL::route('export.entries')
        activo: "exportación/mostrador/entradas",
        permiso: [3002],
      },
      {
        title: "Pre-facturación",
        icono: "Dashboard.svg",
        enlace: "Billing", // Modificado de URL::route('export.invoices')
        activo: "exportación/mostrador/Pre-facturación",
        permiso: [3003],
      },
      {
        title: "Cobro en caja",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('checkout_payment/principal')
        activo: "exportación/mostrador/cobro_en_caja",
        permiso: [3004],
      },
    ],
  },

  // Nivel principal: Supervisión Facturación
  {
    title: "Supervisión Facturación",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "exportación/supervisión_facturación",
    permiso: [3005, 3006, 3007], // Rango original: 3005 a 3007
    hijos: [
      {
        title: "Facturación administrativa",
        icono: "Dashboard.svg",
        enlace: "FactAdmin", // Modificado de URL::route('export.fact_admin')
        activo:
          "exportación/supervisión_facturación/facturación_administrativa",
        permiso: [3005],
      },
      {
        title: "Batch Facturación",
        icono: "Dashboard.svg",
        enlace: "BatchFat",
        activo: "exportación/supervisión_facturación/batch_facturación",
        permiso: [3006],
      },
      {
        title: "Batch Cancelación",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('export.batch_exp_cancel')
        activo: "exportación/supervisión_facturación/batch_cancelación",
        permiso: [3007],
      },
    ],
  },

  // Nivel principal: ACAS
  {
    title: "ACAS",
    icono: "Dashboard.svg",
    enlace: "ACAS", // Modificado de URL::route('export.acas.acasIndex')
    activo: "exportación/acas",
    permiso: [3008],
    hijos: [],
  },

  // Nivel principal: Andén
  {
    title: "Andén",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "exportación/andén",
    permiso: [3009, 3010, 3011], // Rango original: 3009 a 3011
    hijos: [
      {
        title: "Entradas",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('export.entries')
        activo: "exportación/andén/entradas",
        permiso: [3009],
      },
      {
        title: "Auditor",
        icono: "Dashboard.svg",
        enlace: "Auditor",
        activo: "exportación/andén/auditor",
        permiso: [3010],
      },
      {
        title: "Aceptación",
        icono: "Dashboard.svg",
        enlace: "Acceptance", // Modificado de URL::route('export.entries')
        activo: "exportación/andén/aceptación",
        permiso: [3011],
      },
    ],
  },

  // Nivel principal: Despacho
  {
    title: "Despacho",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "exportación/despacho",
    permiso: [3012, 3013, 3014, 3015], // Rango original: 3012 a 3015
    hijos: [
      {
        title: "Salidas",
        icono: "Dashboard.svg",
        enlace: "Departures", // Modificado de URL::route('export.departures')
        activo: "exportación/despacho/salidas",
        permiso: [3012],
      },
      {
        title: "Rezagos",
        icono: "Dashboard.svg",
        enlace: "Lags", // Modificado de URL::route('export.lags')
        activo: "exportación/despacho/rezagos",
        permiso: [3013],
      },
      {
        title: "Desistimientos",
        icono: "Dashboard.svg",
        enlace: "Withdrawals", // Modificado de URL::route('export.withdrawls')
        activo: "exportación/despacho/desistimientos",
        permiso: [3014],
      },
      // 'Transmisión AMS*' fue omitido por estar comentado en el original
    ],
  },

  // Nivel principal: Incidencias
  {
    title: "Incidencias",
    icono: "Dashboard.svg",
    enlace: "#", // Mantenido como '#'
    activo: "exportación/incidencias",
    permiso: [3016, 3017, 3018], // Rango original: 3016 a 3018
    hijos: [
      {
        title: "Incidencias operativas",
        icono: "Dashboard.svg",
        enlace: "Incidents", // Modificado de URL::route('incidents')
        activo: "exportación/incidencias/incidencias_operativas",
        permiso: [3016],
      },
      {
        title: "Irregularidades SAT",
        icono: "Dashboard.svg",
        enlace: "Exp_Irregularities_sat",
        activo: "exportación/incidencias/irregularidades_SAT",
        permiso: [3017],
      },
      {
        title: "UPD M/H",
        icono: "Dashboard.svg",
        enlace: "UPD", // Modificado de URL::route('export.upd')
        activo: "exportación/incidencias/upd_m_h",
        permiso: [3018],
      },
    ],
  },

  // Nivel principal: Kárdex
  {
    title: "Kárdex",
    icono: "Dashboard.svg",
    enlace: "ExpKardex", // Modificado de URL::route('reports.kardex_expo')
    activo: "exportación/kárdex",
    permiso: [3019],
    hijos: [],
  },

  // Nivel principal: Cotizador Servicios de Exportación
  {
    title: "Cotizador Servicios de Exportación",
    icono: "Dashboard.svg",
    enlace: "Quote",
    activo: "exportación/cotizador_servicios_de_exportación",
    permiso: [3020],
    hijos: [],
  },

  // Nivel principal: Reportes Exportación
  {
    title: "Reportes Exportación",
    icono: "Dashboard.svg",
    enlace: "#", // Modificado de null
    activo: "exportación/reportes_exportación",
    permiso: [
      3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032,
      3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042,
    ], // Rango original: 3021 a 3041 + 3042
    hijos: [
      {
        title: "Inventario exportación",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.warehouse')
        activo: "exportación/reportes_exportación/inventario_exportación",
        permiso: [3021],
      },
      // Nivel 2: Mostrador
      {
        title: "Mostrador",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "exportación/reportes_exportación/mostrador",
        permiso: [3022, 3023, 3024], // Rango original: 3022 a 3024
        hijos: [
          {
            title: "Entradas Exportación por guía registrada",
            icono: "Dashboard.svg",
            enlace: "EntradasExpo", // Modificado de URL::route('reports.ens_expo')
            activo:
              "exportación/reportes_exportación/mostrador/entradas_exportación_por_guia_registrada",
            permiso: [3022],
          },
          {
            title: "Product Expo",
            icono: "Dashboard.svg",
            enlace: "ProductExpo", // Modificado de URL::route('reports.product_expo')
            activo: "exportación/reportes_exportación/mostrador/product_expo",
            permiso: [3023],
          },
          {
            title: "Cliente 0000",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.client0_expo')
            activo: "exportación/reportes_exportación/mostrador/cliente_0000",
            permiso: [3024],
          },
        ],
      },
      // Nivel 2: Cajas
      {
        title: "Cajas",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "exportación/reportes_exportación/cajas",
        permiso: [3025, 3026, 3027], // Rango original: 3025 a 3027
        hijos: [
          {
            title: "Kardex",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.checkout_kardex')
            activo: "exportación/reportes_exportación/cajas/kardex",
            permiso: [3025],
          },
          {
            title: "General",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.checkout')
            activo: "exportación/reportes_exportación/cajas/general",
            permiso: [3026],
          },
          {
            title: "Tómbola",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.checkout_money_container')
            activo: "exportación/reportes_exportación/cajas/tombola",
            permiso: [3027],
          },
        ],
      },
      // Nivel 2: Facturación
      {
        title: "Facturación",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "exportación/reportes_exportación/facturación",
        permiso: [3028, 3029, 3030], // Rango original: 3028 a 3030
        hijos: [
          {
            title: "Facturas canceladas por Usuario",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.cancels_expo')
            activo:
              "exportación/reportes_exportación/facturación/facturas_canceladas_por_usuario",
            permiso: [3028],
          },
          {
            title: "Productividad Servicio Exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.product_service_expo')
            activo:
              "exportación/reportes_exportación/facturación/productividad_servicio_exportación",
            permiso: [3029],
          },
          {
            title: "Facturas por horas al día usuario",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.product_invoice_hour_expo')
            activo:
              "exportación/reportes_exportación/facturación/facturas_por_horas_al_dia_usuario",
            permiso: [3030],
          },
        ],
      },
      // Nivel 2: Andén
      {
        title: "Andén",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "exportación/reportes_exportación/andén",
        permiso: [3031, 3032, 3033, 3034, 3035, 3036], // Rango original: 3031 a 3036
        hijos: [
          {
            title: "Auditoría de Peso/Volumen",
            icono: "Dashboard.svg",
            enlace: "CubiscanExpo", // Modificado de URL::route('reports.cubiscan_expo')
            activo:
              "exportación/reportes_exportación/andén/auditoría_de_peso_volumen",
            permiso: [3031],
          },
          {
            title: "Medición por báscula",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.lifttruck_load_audit_expo')
            activo:
              "exportación/reportes_exportación/andén/medición_por_báscula",
            permiso: [3032],
          },
          {
            title: "Cubiscan por cliente, Naturaleza, Destino",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.cubiscan_audit_expo')
            activo:
              "exportación/reportes_exportación/andén/cubiscan_por_cliente_naturaleza_destino",
            permiso: [3033],
          },
          {
            title: "Productividad Cubiscan",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.product_cubi_expo')
            activo:
              "exportación/reportes_exportación/andén/productividad_cubiscan",
            permiso: [3034],
          },
          {
            title: "Aceptación Exportación Origen MEX",
            icono: "Dashboard.svg",
            enlace: "EntExpo", // Modificado de URL::route('reports.ent_expo')
            activo: "exportación/reportes_exportación/andén/aceptación_exportación_origen_mex",
            permiso: [3035],
          },
          {
            title: "Trazabilidad por guía de exportación",
            icono: "Dashboard.svg",
            enlace: "#", // Modificado de URL::route('reports.exp_tracking')
            activo:
              "exportación/reportes_exportación/andén/trazabilidad_por_guía_de_exportación",
            permiso: [3036],
          },
        ],
      },
      // Nivel 2: Despacho
      {
        title: "Despacho",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de null
        activo: "exportación/reportes_exportación/despacho",
        permiso: [3037, 3038, 3039, 3040, 3041], // Rango original: 3037 a 3041
        hijos: [
          {
            title: "Guías Despachadas Exportación",
            icono: "Dashboard.svg",
            enlace: "DeparturesExpo", // Modificado de URL::route('reports.dep_expo')
            activo:
              "exportación/reportes_exportación/despacho/guías_despachadas_exportación",
            permiso: [3037],
          },
          {
            title: "Vuelos Exportación",
            icono: "Dashboard.svg",
            enlace: "VuelosExportacion", // Modificado de URL::route('reports.general-office')
            activo:
              "exportación/reportes_exportación/despacho/vuelos_exportación",
            permiso: [3038],
          },
          {
            title: "Rezagos",
            icono: "Dashboard.svg",
            enlace: "DespachoRezagos", // Modificado de URL::route('reports.exp_lags')
            activo: "exportación/reportes_exportación/despacho/rezagos",
            permiso: [3039],
          },
          {
            title: "Desistimientos",
            icono: "Dashboard.svg",
            enlace: "DesistimientosDespacho", // Modificado de URL::route('reports.exp_withdrawls')
            activo: "exportación/reportes_exportación/despacho/desistimientos",
            permiso: [3040],
          },
          {
            title: "Productividad Despacho",
            icono: "Dashboard.svg",
            enlace: "DespachoExpo", // Modificado de URL::route('reports.product_dep_expo')
            activo:
              "exportación/reportes_exportación/despacho/productividad_despacho",
            permiso: [3041],
          },
          {
            title: "Transmisión AMS",
            icono: "Dashboard.svg",
            enlace: "AmsReport", // Modificado de URL::route('reports.product_dep_expo')
            activo:
              "exportación/reportes_exportación/despacho/ams",
            permiso: [3015],
          },
        ],
      },
      // Nivel 2: Anual
      {
        title: "Anual",
        icono: "Dashboard.svg",
        enlace: "#", // Modificado de URL::route('reports.annual_awb_expo')
        activo: "exportación/reportes_exportación/anual",
        permiso: [3042],
      },
    ],
  },
];

export const getGestionDeAlmacenMenu = () =>
  getFilteredMenu(gestionDeAlmacenMenu);

const MenuItem = ({
  item,
  activePath,
  onSetActive,
  onHoverChange,
  hoveredItem,
  onComponentChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.hijos && item.hijos.length > 0;

  // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
  const currentPath = activePath || "";

  // Lógica para determinar el resaltado
  const isCurrentActive = item.activo === currentPath;
  const isAncestorActive =
    currentPath.startsWith(item.activo + "/") && !isCurrentActive;

  // Colapso automático/apertura si es parte del path activo
  useEffect(() => {
    if (isAncestorActive || isCurrentActive) {
      setIsOpen(true);
    }
  }, [isAncestorActive, isCurrentActive]);

  // Lógica de Hover (se mantiene)
  const isHighlighted = item.title === hoveredItem;
  const hoverProps = hasChildren
    ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
      }
    : {};

  // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
  const handleItemClick = (e) => {
    // 1. Lógica de Colapso (Si tiene hijos)
    if (hasChildren) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }

    // 2. Lógica de Navegación/Selección (Elementos hoja)
    else {
      e.preventDefault();

      if (onComponentChange) {
        sessionStorage.setItem('currentModule', item.enlace !== '#' ? item.enlace : '');
        // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
        onComponentChange(item.enlace, item.activo);
      }

      // onSetActive ya no se llama localmente porque Admin.js lo maneja.
    }
  };

  // Determina las clases de estilo (se mantiene)
  let itemClass = "";
  if (isCurrentActive) {
    itemClass = "is-active";
  } else if (isAncestorActive) {
    itemClass = "is-ancestor";
  }

  return (
    <li
      className={`menu-item ${item.activo} ${itemClass} ${
        isHighlighted ? "highlighted" : ""
      }`}
      {...hoverProps}
    >
      <a
        href={item.enlace}
        onClick={handleItemClick}
        className={`
          menu-link 
          text-white 
          px-3 
          d-flex 
          justify-content-between 
          align-items-center 
          ${item.enlace === sessionStorage.getItem("currentModule") ? 'active' : ''}
          `}
      >
        {item.title}
        {hasChildren && <span className="arrow">{isOpen ? "▲" : "▼"}</span>}
      </a>

      {/* Llamada Recursiva: Pasamos todos los props necesarios */}
      {hasChildren && (
        <ul className="submenu" style={{ display: isOpen ? "block" : "none" }}>
          {item.hijos.map((child, index) => (
            <MenuItem
              key={index}
              item={child}
              activePath={activePath}
              onSetActive={onSetActive} // Dummy
              onHoverChange={onHoverChange}
              hoveredItem={hoveredItem}
              onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const MenuGestion = ({ activePath, onComponentChange }) => {
  // Estados locales (solo Hover)
  const [hoveredItem, setHoveredItem] = useState(null);
  const menuItems = getGestionDeAlmacenMenu();
  const handleHoverChange = (title) => {
    setHoveredItem(title);
  };

  // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
  const handleSetActiveDummy = () => {};

  return (
    <nav className="menu-importacion">
      <ul className="menu-list">
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.title || index}
            item={item}
            activePath={activePath} // <-- Recibido de Admin.js
            onSetActive={handleSetActiveDummy}
            onHoverChange={handleHoverChange}
            hoveredItem={hoveredItem}
            onComponentChange={onComponentChange} // <-- Función enviada al fondo
          />
        ))}
      </ul>
    </nav>
  );
};

export default MenuGestion;
